import { render } from "./TemplateEditor.vue?vue&type=template&id=a3f8e5e6"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=a3f8e5e6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__